import type { ModuleId, ModuleSource } from "../types";

// TODOS os módulos são LAZY: cada HTML vira um chunk separado, carregado sob demanda.
// Antes os módulos 1-13 eram EAGER — ~1,65MB de HTML inlined no bundle inicial + DOMParser
// nos 13 no startup (bloqueando a thread). Era a maior causa de lentidão de carregamento
// (ver ERR-023). Agora o bundle inicial não carrega HTML de módulo nenhum; a busca é
// indexada em background (ver buildSearchIndex em utils/modules.ts).
//
// Glob com wildcard simples (*) — sem brace expansion, confiável no build do Cloudflare Pages.
// O Vite cria um chunk separado para cada arquivo HTML.
const _modules = import.meta.glob("./modules/*.html", {
  as: "raw",
  eager: false
}) as Record<string, () => Promise<string>>;

function loaderFor(fileName: string): () => Promise<string> {
  const key = Object.keys(_modules).find((k) => k.endsWith("/" + fileName));
  if (key) return _modules[key];
  return () => Promise.reject(new Error(`Chunk de módulo não encontrado: ${fileName}`));
}

interface ModuleMeta {
  id: ModuleId;
  number: number | null;
  title: string;
  fileName: string;
}

// Ordem fixa (CLAUDE.md §4b): clínicos NUMERADOS 1…N, que crescem por acréscimo no fim;
// depois a cauda — Calculadoras, Pediatria, Caderno, Referências — com slug estável e SEM
// número. Módulo clínico novo entra como N+1 e não move mais nada.
const META: ModuleMeta[] = [
  { id: "modulo-01", number: 1, title: "Via aérea e intubação orotraqueal", fileName: "modulo_01_via_aerea_iot.html" },
  { id: "modulo-02", number: 2, title: "Pós-intubação e confirmação", fileName: "modulo_02_pos_intubacao_confirmacao.html" },
  { id: "modulo-03", number: 3, title: "Ventilação mecânica invasiva", fileName: "modulo_03_ventilacao_mecanica.html" },
  { id: "modulo-04", number: 4, title: "Manutenção de sedoanalgesia em UTI", fileName: "modulo_04_manutencao_sedoanalgesia.html" },
  { id: "modulo-05", number: 5, title: "Drogas vasoativas em medicina intensiva", fileName: "modulo_05_drogas_vasoativas.html" },
  { id: "modulo-06", number: 6, title: "Distúrbios hidroeletrolíticos", fileName: "modulo_06_disturbios_hidroeletroliticos.html" },
  { id: "modulo-07", number: 7, title: "Antibióticos em UTI e sepse", fileName: "modulo_07_antibioticos_sepse.html" },
  { id: "modulo-08", number: 8, title: "Febre nova em UTI", fileName: "modulo_08_febre_uti.html" },
  { id: "modulo-09", number: 9, title: "Neutropenia febril", fileName: "modulo_09_neutropenia_febril.html" },
  { id: "modulo-10", number: 10, title: "Neuroemergências", fileName: "modulo_10_neuroemergencias.html" },
  { id: "modulo-11", number: 11, title: "Síndrome coronariana aguda", fileName: "modulo_11_sca_iam_trombolise.html" },
  { id: "modulo-12", number: 12, title: "Tromboembolismo pulmonar agudo", fileName: "modulo_12_tep_aguda.html" },
  { id: "modulo-13", number: 13, title: "Cetoacidose diabética e estado hiperosmolar", fileName: "modulo_13_cad_ehh.html" },
  { id: "modulo-14", number: 14, title: "Perfusão tecidual e monitorização hemodinâmica", fileName: "modulo_14_perfusao_hemodinamica.html" },
  { id: "modulo-15", number: 15, title: "Acessos vasculares e procedimentos à beira do leito", fileName: "modulo_15_acessos_procedimentos.html" },
  { id: "calculadoras", number: null, title: "Calculadoras interativas (adulto)", fileName: "calculadoras_interativas.html" },
  { id: "pediatria", number: null, title: "Emergências pediátricas", fileName: "emergencias_pediatricas.html" },
  { id: "caderno", number: null, title: "Caderno de questões", fileName: "caderno_questoes.html" },
  { id: "referencias", number: null, title: "Referências consolidadas", fileName: "referencias.html" }
];

export const moduleSources: ModuleSource[] = META.map((m) => ({
  id: m.id,
  number: m.number,
  title: m.title,
  fileName: m.fileName,
  html: "", // Lazy: nenhum HTML no bundle inicial
  loadHtml: loaderFor(m.fileName)
}));
